import { apiClient } from '../client'
import type { AuthKey, CreateAuthKeyRequest, CreateAuthKeyResponse } from '@milliswift/types'

/**
 * API keys for connecting a device agent.
 *
 * `create` is the only call that ever returns the raw key, and only once.
 */
export const authKeysApi = {
  list: () => apiClient.get<AuthKey[]>('/api/v1/auth-keys').then((r) => r.data),

  create: (data: CreateAuthKeyRequest) =>
    apiClient.post<CreateAuthKeyResponse>('/api/v1/auth-keys', data).then((r) => r.data),

  revoke: (keyId: string) =>
    apiClient.delete(`/api/v1/auth-keys/${keyId}`).then(() => undefined),

  regenerate: (keyId: string) =>
    apiClient
      .post<CreateAuthKeyResponse>(`/api/v1/auth-keys/${keyId}/regenerate`)
      .then((r) => r.data),
}
